import { forwardRef, memo } from 'react';

import { Button, ButtonProps } from '../../designSystem/Button';
import { cn } from '../../lib/styles';

import styles from './MagicButton.module.css';

interface MagicButtonProps extends ButtonProps {
  gradient?: boolean;
}

const MagicSvg = () => {
  return (
    <svg
      className={cn(styles.magicSvg, 'absolute z-1!')}
      xmlns="http://www.w3.org/2000/svg"
      width="226"
      height="213"
      viewBox="0 0 226 213"
      fill="none"
    >
      <g filter="url(#filter0_f_7002_34600)">
        <ellipse
          cx="106.281"
          cy="100.02"
          rx="65.9762"
          ry="43.3274"
          transform="rotate(12.7526 106.281 100.02)"
          fill="#6886FF"
          fillOpacity="0.3"
        />
      </g>
      <g filter="url(#filter1_f_7002_34600)">
        <ellipse
          cx="138.947"
          cy="113.708"
          rx="57.6759"
          ry="29.7735"
          transform="rotate(12.7526 138.947 113.708)"
          fill="#FF9999"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_7002_34600"
          x="0.0202103"
          y="14.114"
          width="212.522"
          height="171.813"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="20.5983" result="effect1_foregroundBlur_7002_34600" />
        </filter>
        <filter
          id="filter1_f_7002_34600"
          x="53.996"
          y="53.683"
          width="169.901"
          height="120.05"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="14.1546" result="effect1_foregroundBlur_7002_34600" />
        </filter>
      </defs>
    </svg>
  );
};

const MagicButtonBase = (
  { className, children, disabled, gradient = true, ...rest }: MagicButtonProps,
  ref: React.Ref<HTMLButtonElement>,
) => {
  return (
    <Button
      ref={ref}
      variant="primary"
      className={cn('relative overflow-hidden! [&_*]:z-10', className, {
        [[
          'enabled:shadow-xsm enabled:border-none',
          'enabled:bg-gradient-to-r enabled:from-[#035BB9] enabled:from-[2.4%] enabled:to-[#680FBB] enabled:to-[100%]',
          'before:absolute before:inset-0 before:bg-transparent before:animate-pulse before:transition-all',
          'hover:before:bg-gradient-to-r hover:before:from-white/20 hover:before:via-transparent hover:before:to-white/10',
        ].join(' ')]: gradient,
      })}
      disabled={disabled}
      {...rest}
    >
      <span>{children}</span>

      {!disabled ? <MagicSvg /> : null}
    </Button>
  );
};

export const MagicButton = memo(forwardRef(MagicButtonBase));
